//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormAccessRequestTableComponent from '@/apps/data-platform/components/FormAccessRequestTableComponent.vue';
import FormMetadataTableComponent from '@/apps/data-platform/components/FormMetadataTableComponent.vue';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import DialogsComponent from '@/components/DialogsComponent.vue';
import { PATTERNS_VALIDATION, ALL_TABLES_OPTION, TYPSE_SENSE_TYPE_OBJECTS, ACCESS_TYPE_FLOW, TYPE_CHANGE_METADA } from '@/js/constants';
export default {
  props: {
    element: {
      type: String,
      default: ''
    }
  },
  components: {
    FormMetadataTableComponent: FormMetadataTableComponent,
    DialogsComponent: DialogsComponent,
    FormAccessRequestTableComponent: FormAccessRequestTableComponent
  },
  data: function data() {
    return {
      flagVideo: true,
      actualVideo: [],
      element_path: null,
      module_path: null,
      objToRequest: {},
      object_id: null,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      is_load: false,
      objToWork: {},
      MODAL_NAME: 'ListObjectsSearch',
      test: "projects/dev-intercorp-data-storage/locations/us/entryGroups/@bigquery/entries/cHJvamVjdHMvZGV2LWludGVyY29ycC1kYXRhLXN0b3JhZ2UvZGF0YXNldHMvYmlfaXRjX2F0dHJpYnV0ZV9wYXJ0eS90YWJsZXMvYmFfaXRjX2F0dHJfcmV0YWls"
    };
  },
  created: function created() {
    console.log(this.$route.params);
    this.object_id = this.$route.params.object_id;
    var objetoJSON = decodeURIComponent(this.object_id);

    // Analiza la cadena JSON para obtener el objeto JavaScript original
    this.objToWork = JSON.parse(objetoJSON);
    this.onVerTable();
  },
  computed: {
    items: function items() {
      return [this.traductor('help_center.news'), this.traductor('help_center.read'), this.traductor('help_center.videos'), this.traductor('help_center.sugerences')];
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onVerTable: function onVerTable() {
      var _this = this;
      console.log("asd");
      //let modalName = this.MODAL_NAME_METADATA_VIEW
      var rowData = {
        relativeResourceName: this.objToWork.relativeResourceName,
        objectId: this.objToWork.objectId,
        tableReference: this.objToWork.tableReference,
        domain_table: this.objToWork.domain_table,
        domain: this.objToWork.domain,
        index_node: '1'
      };

      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: this.objToWork.relativeResourceName,
        pageSize: 10,
        email: window.userInfo.email,
        //index_node: rowData.index_node,
        domain_table: this.objToWork.domain_table,
        source: this.objToWork.source ? this.objToWork.source : "bigquery"
      };
      console.log("gotobackend");
      AssignmentsService.getListTagEntry(params).then(function (response) {
        console.log("terminao", response.data);
        console.log("log", rowData);
        if (response.code === 200) {
          _this.objToRequest = response.data;
          _this.objToRequest.item = rowData;
          _this.objToRequest.tipo = 'edicion';
          _this.is_load = true;

          //this.$bvModal.show(modalName)
          //this.key_view += 1
          //this.$refs[modalName].onOpen()
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onSubmit: function onSubmit() {
      this.$refs['sugerences'].onSubmit();
    }
  }
};